// US-10: «Validation flow» включается когда у залогиненного пользователя
// уже есть ≥ 2 личных пина. На mount-е делаем auto-fit к их bbox один раз
// за сессию (sessionStorage флаг), потом возвращаем флаг для UI-индикатора.
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/lib/auth-client';
import { pins as pinsApi } from '@/lib/api';
import { emit } from '@/lib/events';

const SESSION_KEY = 'relocation_pins_autofit_done_v1';
const MIN_PINS = 2;

export function useValidationMode(): { active: boolean; count: number } {
  const { data: session } = useSession();
  const { data: pins } = useQuery({
    queryKey: ['pins'],
    queryFn: () => pinsApi.list(),
    enabled: !!session,
  });
  const count = pins?.length ?? 0;
  const active = !!session && count >= MIN_PINS;

  useEffect(() => {
    if (!active || !pins) return;
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SESSION_KEY)) return;
    const points = pins.map((p) => ({ lat: p.lat, lon: p.lon }));
    if (points.length < MIN_PINS) return;
    emit('places:flyToBounds', { points });
    sessionStorage?.setItem(SESSION_KEY, '1');
  }, [active, pins]);

  return { active, count };
}
